import React, { useState, useCallback } from 'react';
import styled from 'styled-components';
import { Form, Formik } from 'formik';

import { Disclaimer } from '../../shared';
import { RadioButtonGroup } from '../../lib/Form';
import { MarketDataTabType } from './enums';
import MarketDataTab from './MarketDataTab';

interface Props {
  buttonGroupOptions: any[];
  getMarketIframeUrl: (actualTab: MarketDataTabType) => string;
  disclaimerContent: string;
}

const emptyHandler = () => {};
const radioButtonsFieldName = 'navigationButtons';
const initialValues = {
  [radioButtonsFieldName]: MarketDataTabType.DetailedQuote,
};
const MarketDataPage: React.FC<Props> = ({
  buttonGroupOptions,
  getMarketIframeUrl,
  disclaimerContent,
}) => {
  const [actualTab, setActualTab] = useState(MarketDataTabType.DetailedQuote);
  const setActualTabCallback = useCallback((option) => setActualTab(option.key), []);
  return (
    <>
      {/* TODO: Maybe we can create navigation component not used in forms and refactor this part */}
      <Formik
        onSubmit={emptyHandler}
        initialValues={initialValues}
        render={() => (
          <Form>
            <RadioButtonGroup
              name={radioButtonsFieldName}
              options={buttonGroupOptions}
              onClickHandler={setActualTabCallback}
              hasFullWidth
              mobile={{
                vertical: true,
                horizontal: false,
                noMargin: true,
              }}
            />
          </Form>
        )}
      />
      <MarketDataTab iframeUrl={getMarketIframeUrl(actualTab)} />
      <Disclaimer withPadding>
        <DisclaimerContent
          className="sol-foot-note"
          dangerouslySetInnerHTML={{ __html: disclaimerContent }}
        ></DisclaimerContent>
      </Disclaimer>
    </>
  );
};

const DisclaimerContent = styled.div`
  p {
    display: inline;
  }
`;

export default MarketDataPage;
